<template>
    <AuthLayout v-bind="customerSharedData.getAuthLayoutProps()">
        <ApiForm
            :url="url"
            method="POST"
            ref="apiFormRef"
        >
            <FormControl
                label="New password"
                :error="
                    apiFormRef?.response?.getValidationError(
                        RequestBodyKeyEnum.Customer_NewPassword_Password,
                    )
                "
            >
                <TextInput
                    type="password"
                    class="w-full"
                    :name="RequestBodyKeyEnum.Customer_NewPassword_Password"
                    required
                />
            </FormControl>

            <FormControl label="New password confirmation">
                <TextInput
                    type="password"
                    class="w-full"
                    :name="
                        RequestBodyKeyEnum.Customer_NewPassword_PasswordConfirmation
                    "
                    required
                />
            </FormControl>

            <Button
                @click="apiFormRef?.submit()"
                :loading="apiFormRef?.loading.valueOf()"
                class="w-full mt-2"
            >
                Save new password
            </Button>

            <div
                v-if="turnstileEnabled"
                class="mt-4 flex justify-center"
            >
                <div
                    class="cf-turnstile"
                    :data-sitekey="turnstileSiteKey"
                ></div>
            </div>
        </ApiForm>
    </AuthLayout>
</template>

<script setup lang="ts">
    import { ref } from 'vue'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import TextInput from '@/Shared/Component/Forms/TextInput.vue'
    import Button from '@/Shared/Component/Button.vue'
    import AuthLayout from '@/Shared/Layout/Customer/Auth/AuthLayout.vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import CustomerSharedData from '@/Shared/Entity/CustomerSharedData'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'

    interface CreateCustomerNewPasswordProps {
        customerSharedDataData: CustomerSharedData
        turnstileEnabled: boolean
        turnstileSiteKey: string
        token: string
    }

    const props = defineProps<CreateCustomerNewPasswordProps>()
    const customerSharedData = CustomerSharedData.hydrate(
        props.customerSharedDataData,
    )
    const apiFormRef = ref<ApiFormRefType>(null)
    const url = new UrlFactory().makeCustomerCreateNewPasswordPageUrl(
        props.token,
    )
</script>
